import React, { FC } from 'react';
import styled from 'styled-components';
import { Card } from '@hox/ui/Card';
import { AnimatedResizingContent } from '@hox/ui/AnimatedResizingContent';

// Model
// -----------------------------------------------------------------------------

interface IAuthCardProps {}

// Styles
// -----------------------------------------------------------------------------

const AuthCardStyled = styled(Card)`
  position: relative;
  padding: 3rem;
  overflow: hidden;
`;

// Component
// -----------------------------------------------------------------------------

export const AuthCard: FC<IAuthCardProps> = ({ children, ...restProps }) => (
  <AuthCardStyled {...restProps}>
    <AnimatedResizingContent>{children}</AnimatedResizingContent>
  </AuthCardStyled>
);
